package org.lennycodes.hldi.pages.admin

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.style.breakpoint.ResponsiveValues
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.backend.*
import org.lennycodes.hldi.backend.db_service.deleteGalleryImage
import org.lennycodes.hldi.data.GalleryImage
import org.lennycodes.hldi.pages.admin.AdminRepository.getGalleryImages
import org.lennycodes.hldi.styles.AddAdminButtonStyle
import org.lennycodes.hldi.styles.UsersTitleStyle


@Composable
fun Gallery() {

    val scope = rememberCoroutineScope()

    var showGalleryDialog by remember {
        mutableStateOf(false)
    }

    var refreshKey by remember {
        mutableStateOf(0)
    }

    var images by remember {
        mutableStateOf<List<GalleryImage>>(emptyList())
    }


    var selectedImage by remember {
        mutableStateOf<GalleryImage?>(null)
    }



    LaunchedEffect(refreshKey) {
     images = getGalleryImages()
    }




    if (showGalleryDialog) {

        AddToGalleryDialog(

            onDismiss = {
                showGalleryDialog = false
            },

            onSuccess = {
                refreshKey++
            }

        )

    }




    if (selectedImage != null) {

        UpdateGalleryDialog(

            image = selectedImage!!,

            onDismiss = {
                selectedImage = null
            },

            onSuccess = {

                selectedImage = null
                refreshKey++

            }

        )

    }





    Column(

        modifier = Modifier
            .fillMaxWidth()
            .padding(32.px)

    ) {



        Row(

            modifier = Modifier
                .fillMaxWidth()
                .padding(16.px),

            horizontalArrangement = Arrangement.SpaceBetween,

            verticalAlignment = Alignment.CenterVertically

        ) {


            H3(
                attrs = UsersTitleStyle.toAttrs()
            ) {

                Text("RN-HLDI Gallery")

            }



            Button(

                modifier = Modifier
                    .padding(10.px,20.px)
                    .then(AddAdminButtonStyle.toModifier()),

                onClick = {
                    showGalleryDialog = true
                }

            ){

                Text("+ New Image")

            }

        }





        // Gallery Grid

        SimpleGrid(
            numColumns = ResponsiveValues(
                base = 1,
                sm = 1,
                md = 2,
                lg = 3,
                xl = 4,
                xxl = 5
            ),
            modifier = Modifier.gap(20.px)

        ){


            images.forEach { image ->


                Div(

                    attrs = Modifier
                        .padding(16.px)
                        .toAttrs()

                ){


                    Img(

                        src = image.url,

                        attrs = Modifier
                            .fillMaxWidth()
                            .height(220.px)
                            .toAttrs()

                    )



                    H4 {

                        Text(image.title)

                    }



                    P {

                        Text(image.category)

                    }





                    Row(

                        horizontalArrangement =
                            Arrangement.spacedBy(10.px)

                    ){



                        Button(

                            onClick = {

                                selectedImage = image

                            }

                        ){

                            Text("Edit")

                        }





                        Button(

                            onClick = {


                                scope.launch {


                                    deleteGalleryImage(
                                        image
                                    )


                                    refreshKey++

                                }


                            }

                        ){

                            Text("Delete")

                        }



                    }



                }


            }


        }


    }

}